import {memo, PropTypes, propTypesExact, shapeComponent, ShapeComponent, useI18n, View} from "shared/base"
import AppHistory from "shared/history"
import Button from "components/chalky-layout/button"
import ButtonUnderscore from "components/chalky-layout/button-underscore"
import {digg} from "diggerize"
import DogBoneImage from "./dog-bone-dark-blue.png"
import {FlashNotifications as FlashMessage} from "flash-notifications"
import {Image} from "react-native"
import {loading} from "components/layout/loading-blocker"
import Modal from "components/modal"
import PageContentsPresentation from "components/page-contents/presentation"
import React from "react"
import {SchoolClass} from "models"
import {WithDefaultStyle} from "@kaspernj/api-maker/build/utils/default-style"

export default memo(shapeComponent(class RoutesUserSchoolClassesClassSpaceHowAreYouDoingModal extends ShapeComponent {
  static propTypes = propTypesExact({
    onRequestClose: PropTypes.func.isRequired,
    schoolClass: PropTypes.instanceOf(SchoolClass).isRequired
  })

  setup() {
    const {t} = useI18n({namespace: "js.routes.user.school_classes.class_space.how_are_you_doing_modal"})

    this.t = t
  }

  render() {
    const {t} = this.tt
    const {onRequestClose, schoolClass} = this.p

    return (
      <Modal cardProps={this.modalCardProps ||= {childrenProps: {style: {backgroundColor: "#f2efff"}}}} onRequestClose={onRequestClose}>
        <View style={this.headlineViewStyle ||= {alignItems: "center"}}>
          <WithDefaultStyle style={this.headStyle ||= {Text: {color: "#1b1f72", fontFamily: "DreamChaser"}}}>
            <PageContentsPresentation
              identifier="routes/user/school-classes/class-space/how-are-you-doing-modal/headline"
              liquidVariables={this.headlineLiquidVariables ||= {schoolClass}}
            />
          </WithDefaultStyle>
        </View>
        <View
          style={this.whiteCardStyle ||= {
            alignItems: "center",
            width: 380,
            padding: 48,
            marginHorizontal: "auto",
            marginVertical: 24,
            backgroundColor: "#fff",
            borderRadius: 48
          }}
        >
          <View style={this.dogBoneImageViewStyle ||= {marginBottom: 10}}>
            <Image source={DogBoneImage} style={this.dogBoneImageStyle ||= {width: 72, height: 72}} />
          </View>
          <WithDefaultStyle style={this.headStyle ||= {Text: {color: "#1b1f72", fontFamily: "HankenGrotesk"}}}>
            <PageContentsPresentation
              identifier="routes/user/school-classes/class-space/how-are-you-doing-modal/start-a-new-woof"
              liquidVariables={this.startANewWoofLiquidVariables ||= {schoolClass}}
            />
          </WithDefaultStyle>
          <Button
            onPress={this.tt.onStartWoofPress}
            primary
            style={this.startWoofButtonStyle ||= {marginTop: 40}}
            title={t(".start_woof")}
          />
        </View>
        <View style={this.skipButtonViewStyle ||= {alignItems: "center"}}>
          <ButtonUnderscore
            onPress={onRequestClose}
            primary
            title={t(".skip_and_go_to_your_woof_space")}
          />
        </View>
      </Modal>
    )
  }

  onStartWoofPress = async () => {
    try {
      await loading(null, async () => {
        const result = await this.p.schoolClass.randomCourse({type: "check_in"})
        const courseUrl = digg(result, "course_url")

        if (!courseUrl) throw new Error("No course URL given")

        AppHistory.push(courseUrl)
      })
    } catch (error) {
      FlashMessage.errorResponse(error)
    }
  }
}))
